module.exports = __webpack_public_path__ + "media/Claimed-Audio.0132f39c.mp3";